
import { throws } from 'assert';
import * as React from 'react';
import CloseIcon from '../../../images/dynamicIcons/closeIcon';
import { UserNotification } from '../../../models/UserNotificationModels';
import { Modal } from '../../components/Modals';




interface UserImportantNotificationProps {
    notification?: UserNotification | null,
    ReadImportantNotification(notification: UserNotification): void
}




export class UserImportantNotification extends React.PureComponent<UserImportantNotificationProps> {




    public render() {

        return (
            <React.Fragment>
                {this.props.notification &&
                    <Modal isOpen={true} isImportant={true} onClose={() => { }}>
                        <div className='general__r-cancel_close button' onClick={() => {
                            if (this.props.notification) {
                                this.props.ReadImportantNotification(this.props.notification)

                            }
                        }}>
                            <CloseIcon />
                        </div>
                        <div className='notification'>
                            <div className='modal-header-large'>{this.props.notification.title != null ? this.props.notification.title : ""}</div>

                            <div style={{ wordBreak: "break-word", paddingRight: "15px", paddingTop:"15px" }}>
                                <p style={{ fontSize:"1.1em", textAlign:"center", margin: "0", whiteSpace: "pre-wrap", wordWrap: "break-word" }}>{this.props.notification.content}</p>
                            </div>
                        </div>


                        <div className='general_offer-modal'>



                        </div>
                    </Modal>

                }

            </React.Fragment>
        )
    }
}


